import { render, staticRenderFns } from "./GroupAssignmentNew.vue?vue&type=template&id=cdb3755a"
import script from "./GroupAssignmentNew.vue?vue&type=script&lang=js"
export * from "./GroupAssignmentNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports